import moment from "moment";

import { DEFAULT_DATE_FORMAT } from "../../constants/dateFormats";
import * as validateRegex from "./regex";

export const isValidDate = date => date && validateRegex.DATE.test(date);

export const isDateWithinLast10Months = date =>
  moment().diff(moment(date, DEFAULT_DATE_FORMAT, true), "months") < 10;
